module.exports = __webpack_public_path__ + "static/media/DateSelect.left.1ae92674.png";